import Loadable from 'react/components/loadable';

const ExerciseDetailsModal = Loadable({
  loader: () => import('../../pages/workouts/exercise_details_modal'),
  type: 'modal',
});

angular.module('gym').value('ExerciseDetailsModal', ExerciseDetailsModal);
